<div id="app-main" class="app-main">
    <div class="app-menu">
        <app-menu>
        </app-menu>
    </div>
    <div
        class="app-overlay"
        (click)="toggleMenu()"
    ></div>
    <div class="app-app">
        <div class="app">
            <div class="app">
                <app-header
                    [isLogin]="isLoggedIn"
                    [userRol]="roles.Admin"
                ></app-header>
                <router-outlet></router-outlet>
                <app-footer></app-footer>
            </div>
        </div>
    </div>
</div>